import { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Plus } from '@agendapro/emerald-icons';
import { useTranslation } from 'react-i18next';
import { ButtonCategory } from '@/UI';
import { devices } from '@/UI/Styles';

import * as St from './SliderFilterButtons.styles';
import { SliderFilterButtonProps } from './types';
import { EditProfileButton } from '@/UI/Atoms/EditProfileButton';
import { editCompanyUrls } from '@/utils/canEditOwnCompany';

export const SliderFilterButtons: FC<SliderFilterButtonProps> = ({ services, dispatch, canEdit }) => {
  const { listOfCategories, currentFilterIds } = services;
  const { t } = useTranslation();
  const isXLarge = useMediaQuery({
    query: devices.XLarge,
  });

  return (
    <St.Wrapper>
      {!!listOfCategories && (
        <>
          {isXLarge ? (
            <St.CategoryContainer>
              {canEdit && (
                <EditProfileButton
                  className="flex w-full h-fit bg-background-primary border border-border-brand border-solid rounded-md p-1 flew-row items-center justify-center gap-1 text-text-brand text-sm hover:bg-background-secondary transition-colors duration-300"
                  url={editCompanyUrls.services}
                  mixpanelEvent="addServices"
                >
                  <Plus size={16} className="[&>path]:fill-icon-brand" />
                  {t('ADD_OR_EDIT_SERVICES')}
                </EditProfileButton>
              )}
              {listOfCategories.map(({ id, name }) => (
                <St.Category key={id}>
                  <ButtonCategory
                    label={name}
                    isCharly={id === 'DISCOUNT'}
                    onClick={() => dispatch({ type: 'SELECT_SINGLE_CATEGORY', payload: id })}
                    isSelected={currentFilterIds.some((categoryId) => categoryId === id)}
                  />
                </St.Category>
              ))}
            </St.CategoryContainer>
          ) : (
            <St.SliderWrapper>
              <St.SliderMobile>
                {listOfCategories.map(({ id, name }) => (
                  <ButtonCategory
                    key={id}
                    isCharly={id === 'DISCOUNT'}
                    label={name}
                    onClick={() => dispatch({ type: 'SELECT_SINGLE_CATEGORY', payload: id })}
                    isSelected={currentFilterIds.some((categoryId) => categoryId === id)}
                  />
                ))}
              </St.SliderMobile>
            </St.SliderWrapper>
          )}
        </>
      )}
    </St.Wrapper>
  );
};
